<template>
    <footer class="footer pt-md-5" id="footer-main">
        <b-container >
        <b-row align-v="start" class="justify-content-xl-between">
            <b-col class="col-md-3 col-12">
                <h6 class="footer-title">{{ $t('userfooter.oursites') }}</h6>
                <img class="footer-line footer-line-fr" src="img/theme/footer_line.png" alt="" />
                <div class="footer-details">
                    <p class="footer-p-details"><a :href="astekgroupUrl" target="_blank" rel="noopener noreferrer">{{ $t("userfooter.astekgroup") }}</a></p>
                    <p class="footer-p-details"><a :href="astekjobUrl" target="_blank" rel="noopener noreferrer">{{ $t("userfooter.astekjob") }}</a></p>
                </div>
            </b-col>
            <b-col class="col-md-3 col-12">
                <h6 class="footer-title">{{ $t('userfooter.followus') }}</h6>
                <img class="footer-line footer-line-fr" src="img/theme/footer_line.png" alt="" />
                <div class="footer-details">
                    <a :href="datas.actus.networks.instagram" target="_blank" rel="noopener noreferrer"><img width="15" src="img/icons/social/instagram.svg" alt="" /></a>&ensp;
                    <a :href="datas.actus.networks.twitter" target="_blank" rel="noopener noreferrer"><img width="17" src="img/icons/social/twitter.svg" alt=""  /></a>&ensp; 
                    <a :href="datas.actus.networks.facebook" target="_blank" rel="noopener noreferrer"><img width="8.5" src="img/icons/social/facebook.svg" alt=""  /></a>&ensp;
                    <a :href="datas.actus.networks.linkedin" target="_blank" rel="noopener noreferrer"><img width="16" src="img/icons/social/linkedIn.svg" alt=""  /></a>
                </div>
            </b-col>
            <b-col class="col-md-3 col-12">
                <h6 class="footer-title">{{ $t('userfooter.contactus') }}</h6>
                <img class="footer-line footer-line-fr" src="img/theme/footer_line.png" alt="" />
                <div class="footer-details">
                    <p class="footer-contact-details">{{ datas.infos.contacts.street }}</p>
                    <p class="footer-contact-details">{{ datas.infos.contacts.address }}</p>
                    <p class="footer-contact-details"><a :href="'mailto:' + datas.infos.contacts.email">{{ datas.infos.contacts.email }} </a></p>
                </div>
            </b-col>
            <b-col class="col-md-3 col-12">
                <div align="center" class="footer-div-part-2 col-lg-12 footer-details footer-legal-mentions" >
                    <p><img width="70" src="img/brand/logo_footer.png" alt="" /></p>
                    <p class="mt-md-3">© {{year}} {{$t('generic.stename')}} | <router-link to="/legalnotice" target="_blank"> {{ $t("userfooter.legalmention") }}</router-link></p>
                </div>
            </b-col> 
        </b-row>
        </b-container>
    </footer>
</template> 

<script>
    import Vue from "vue";
    import datas from '../../datas';
    export default {
        name: "user-footer",
        datas,
        data() {
            return {
                datas,
                //language: localStorage.getItem(Vue.Keys.LANGUAGE),
                language: Vue.i18n.locale(),
                year: new Date().getFullYear()
            };
        },
        computed: {
            astekgroupUrl() {
                //let lan = localStorage.getItem(Vue.Keys.LANGUAGE);
                let lan = Vue.i18n.locale();
                return lan == 'fr'? this.datas.infos.sites.astekgroup.fr : this.datas.infos.sites.astekgroup.en;
            },
            astekjobUrl() {
                //let lan = localStorage.getItem(Vue.Keys.LANGUAGE);
                let lan = Vue.i18n.locale();
                return lan == 'fr'? this.datas.infos.sites.astekjob.fr : this.datas.infos.sites.astekjob.en;
            }            
        }
    }
</script>
